import { redirect } from 'react-router-dom'

import { getUserDetail } from 'api/user/user.query'
import allRoutes from 'shared/lib/allRoutes'
import { isUserLoggedIn } from 'shared/lib/user'

export const privateLoader = (queryClient) => async () => {
  const token = isUserLoggedIn()
  if (token) {
    try {
      const { data } = await queryClient.fetchQuery({ queryKey: ['getUserDetail'], queryFn: getUserDetail })
      return { token: token || null, user: data }
    } catch (error) {
      if (error.status === 401) {
        return redirect(`${allRoutes.login}?from=${location.pathname}${location.search || ''}`)
      }
      return null
    }
  } else {
    return redirect(`${allRoutes.login}?from=${location.pathname}${location.search || ''}`)
  }
}

export const publicLoader = async (e) => {
  if (isUserLoggedIn()) return redirect(allRoutes.projects)
  else return null
}
